import { IconButton, PlusIcon } from '@/lib';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

type EmailTemplateListEmptyStateProps = {
  variant: 'global' | 'filtered';
  onCreate?: () => void;
};

export const EmailTemplateListEmptyState: FC<EmailTemplateListEmptyStateProps> = ({ variant, onCreate }) => {
  const { t } = useTranslation('campaign');

  if (variant === 'filtered') {
    return (
      <div className='rounded-2xl border border-dashed border-secondary-border bg-white p-5 text-sm text-secondary-600'>
        {t('emailWorkspace.templates.noFilteredTemplatesFound')}
      </div>
    );
  }

  return (
    <div className='flex flex-col items-center gap-4 rounded-2xl border border-dashed border-secondary-border bg-white p-8 text-center'>
      <div className='space-y-1'>
        <h3 className='text-base font-semibold text-slate-900'>{t('emailWorkspace.templates.noTemplatesFound')}</h3>
        <p className='text-sm text-secondary-600'>{t('emailWorkspace.templates.noTemplatesFoundDescription')}</p>
      </div>
      {onCreate ? (
        <IconButton
          leadingIcon={<PlusIcon className='size-5 text-white-100' />}
          className='inline-flex justify-center'
          onClick={onCreate}
          text={t('emailWorkspace.templates.createEmailTemplate')}
        />
      ) : null}
    </div>
  );
};
